var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2976 10.6775H2.94262C1.66512 10.6775 0.620117 11.8025 0.620117 13.1775C0.620117 14.5525 1.66512 15.6775 2.94262 15.6775H22.2976C23.5751 15.6775 24.6201 14.5525 24.6201 13.1775C24.6201 11.8025 23.5751 10.6775 22.2976 10.6775Z",
    fill: "#E40000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.a3cf829af9eda78fbb0186719d6be4fa.svg";
export { ForwardRef as ReactComponent };